import FullLicensesDetails from "@/domain/entities/license/FullLicensesDetails";
import { queryKeys } from "@/lib/queryKeys";
import fullLicensesDetailsToDomainMapper from "@/mappers/license/fullLicensesDetailsMapper";
import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import { useQuery } from "@tanstack/react-query";

const useFullLicensesDetails = () => {
    const { licenseManager } = useSdk();

    const {
        data: fullLicensesDetails,
        isLoading,
        error,
    } = useQuery<FullLicensesDetails, Error>({
        queryKey: queryKeys.fullLicensesDetails(),
        queryFn: async () => {
            const details = await licenseManager.getFullLicensesDetails();

            return fullLicensesDetailsToDomainMapper(details);
        },
    });

    return {
        fullLicensesDetails,
        isLoading,
        error,
    };
};

export default useFullLicensesDetails;
